import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { ANCHOR_HEADLINE_CONVERTER_TOKEN, AnchorHeadlineConverter } from './anchor-headline.component.converter'
import { FsComponentConverter } from 'fs-spartacus-common'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        anchorHeadlineFeature: {
          module: () => import('./anchor-headline.module').then((m) => m.AnchorHeadlineModule),
          cmsComponents: ['anchor_headline']
        },
      }
    }),
    {
      provide: ANCHOR_HEADLINE_CONVERTER_TOKEN,
      useExisting: AnchorHeadlineConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        anchor_headline: ANCHOR_HEADLINE_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class AnchorHeadlineFeatureModule {}
